<template>
  <div>
    <div>
      <p>Typography is our system of fonts. Each font conveys the appropriate sentiment to assist our users through each stage of their journey.</p>
      <p>Use typography to present your design and content as clearly and efficiently as possible.</p>
    </div>
    <typography-family />
  </div>
</template>

<script>
import TypographyFamily from './typography/TypographyFamily.vue'

export default {
  components: {
    TypographyFamily,
  },
}
</script>
